"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));
var React = _interopRequireWildcard(require("react"));
var _principles = require("@kbbcomponentlibrary/principles");
var gray = _principles.colors.gray;
var DisclaimerText = (/*#__PURE__*/
0, _styledBase["default"])('p', {
  target: "e8vs0e30",
  label: "DisclaimerText"
})("font-size:", _principles.fonts.size['4XSmall'], ";color:", gray.dark40, ";line-height:1.5;text-align:left;font-style:", function (props) {
  return props.italic ? 'italic' : 'normal';
}, ";font-weight:", function (props) {
  return props.bold ? 'bold' : 'normal';
}, ";", function (props) {
  return !props.margin ? 'margin: 0' : '';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9EaXNjbGFpbWVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1Ca0MiLCJmaWxlIjoiLi4vc3JjL0Rpc2NsYWltZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5pbXBvcnQgKiBhcyBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBjb2xvcnMsIGZvbnRzIH0gZnJvbSAnQGtiYmNvbXBvbmVudGxpYnJhcnkvcHJpbmNpcGxlcyc7XG5cbmNvbnN0IHsgZ3JheSB9ID0gY29sb3JzO1xuXG50eXBlIGRpc2NsYWltZXJQcm9wcyA9IHtcbiAgLyoqIGNoaWxkcmVuICovXG4gIGNoaWxkcmVuPzogUmVhY3QuTm9kZSxcbiAgLyoqIGZvbnQtd2VpZ2h0OiBib2xkICovXG4gIGJvbGQ/OiBib29sZWFuLFxuICAvKiogZm9udC1zdHlsZTogaXRhbGljICovXG4gIGl0YWxpYz86IGJvb2xlYW4sXG4gIC8qKiBmYWxzZSA9IG1hcmdpbjogMCAqL1xuICBtYXJnaW4/OiBib29sZWFuLFxufTtcblxuY29uc3QgRGlzY2xhaW1lclRleHQgPSBzdHlsZWQoJ3AnKWBcbiAgZm9udC1zaXplOiAke2ZvbnRzLnNpemVbJzRYU21hbGwnXX07XG4gIGNvbG9yOiAke2dyYXkuZGFyazQwfTtcbiAgbGluZS1oZWlnaHQ6IDEuNTtcbiAgdGV4dC1hbGlnbjogbGVmdDtcblxuICBmb250LXN0eWxlOiAke3Byb3BzID0+IHByb3BzLml0YWxpYyA/ICdpdGFsaWMnIDogJ25vcm1hbCd9O1xuICBmb250LXdlaWdodDogJHtwcm9wcyA9PiBwcm9wcy5ib2xkID8gJ2JvbGQnIDogJ25vcm1hbCd9O1xuICAke3Byb3BzID0+ICFwcm9wcy5tYXJnaW4gPyAnbWFyZ2luOiAwJyA6ICcnfTtcbmA7XG5cbi8qKiBpbXBvcnQgRGlzY2xhaW1lciBmcm9tIFwiQGtiYmNvbXBvbmVudGxpYnJhcnkvZGlzY2xhaW1lclwiOyAqL1xuY29uc3QgRGlzY2xhaW1lciA9IChwcm9wczogZGlzY2xhaW1lclByb3BzKSA9PiA8RGlzY2xhaW1lclRleHQgey4uLnByb3BzfS8+O1xuXG5EaXNjbGFpbWVyLmRpc3BsYXlOYW1lID0gJ0Rpc2NsYWltZXInO1xuXG5EaXNjbGFpbWVyLmRlZmF1bHRQcm9wcyA9IHtcbiAgbWFyZ2luOiB0cnVlLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRGlzY2xhaW1lcjtcbiJdfQ== */"));
/** import Disclaimer from "@kbbcomponentlibrary/disclaimer"; */

var Disclaimer = function Disclaimer(props) {
  return React.createElement(DisclaimerText, props);
};
Disclaimer.displayName = 'Disclaimer';
Disclaimer.defaultProps = {
  margin: true
};
var _default = Disclaimer;
exports["default"] = _default;
Disclaimer.__docgenInfo = {
  "description": "import Disclaimer from \"@kbbcomponentlibrary/disclaimer\";",
  "methods": [],
  "displayName": "Disclaimer",
  "props": {
    "margin": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "flowType": {
        "name": "boolean"
      },
      "description": "false = margin: 0"
    },
    "children": {
      "required": false,
      "flowType": {
        "name": "ReactNode",
        "raw": "React.Node"
      },
      "description": "children"
    },
    "bold": {
      "required": false,
      "flowType": {
        "name": "boolean"
      },
      "description": "font-weight: bold"
    },
    "italic": {
      "required": false,
      "flowType": {
        "name": "boolean"
      },
      "description": "font-style: italic"
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Disclaimer.js"] = {
    name: "Disclaimer",
    docgenInfo: Disclaimer.__docgenInfo,
    path: "src/Disclaimer.js"
  };
}